import React from "react";
import { Box, Container, Typography, Grid, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const WhyCollaborateSection = () => {
  const navigate = useNavigate();

  const handleNavigateToRegister = () => {
    navigate("/register");
  };
  const features = [
    {
      icon: "🍽️",
      heading: "↗ CUSTOMIZED MEAL PLANS",
      title: "Personalized Meal Planning",
      description:
        "Your health and fitness goals are unique so are our solutions. Fitify crafts tailored meal plans that adapt to your lifestyle, preferences, and progress.",
    },
    {
      icon: "🎓",
      heading: "↗ CERTIFIED PROFESSIONAL",
      title: "Expert Nutrition",
      description:
        "Access expert backed diet advice and workout recommendations. Fitify ensures your plans align with your health history and fitness journey.",
    },
    {
      icon: "📈",
      heading: "↗ LONG TERM RESULTS",
      title: "Sustainable Lifestyle",
      description:
        "We focus on building long term healthy habits. With small, consistent improvements, you'll achieve sustainable results and lasting well being.",
    },
  ];

  const demoFeatures = [
    "Explore customized meal options",
    "See how reminders keep you on track",
    "Preview your weight & wellness program",
  ];

  return (
    <Container maxWidth="xl" sx={{ py: 8, position: "relative", zIndex: 2 }}>
      {/* Section Header */}
      <Box sx={{ textAlign: "center", mb: 8 }}>
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "2rem", md: "2.5rem", lg: "3rem" },
            fontWeight: 700,
            fontFamily: "Outfit",
            color: "#4ef4ff",
            mb: 3,
            lineHeight: 1.2,
          }}
        >
          Why Collaborate with Us
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: "1rem", md: "1.2rem" },
            fontWeight: 400,
            fontFamily: "Outfit",
            color: "#FFFFFF",
            lineHeight: 1.6,
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          Our Commitment to your well being goes beyond the ordinary.
        </Typography>
      </Box>

      {/* Service Pillars Section */}
      <Grid container spacing={{ xs: 4, md: 6 }} sx={{ mb: 8 }}>
        {features.map((feature, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Box sx={{ textAlign: "left", height: "100%" }}>
              {/* Icon */}
              <Box
                sx={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#268088",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 0 24px 0",
                  fontSize: "2rem",
                }}
              >
                {feature.icon}
              </Box>

              {/* Heading */}
              <Typography
                sx={{
                  fontSize: { xs: "0.9rem", md: "1rem" },
                  fontWeight: 600,
                  fontFamily: "Outfit",
                  color: "#5BF2FF",
                  mb: 2,
                }}
              >
                {feature.heading}
              </Typography>

              {/* Horizontal Line */}
              <Box
                sx={{
                  width: "90%",
                  height: "1px",
                  backgroundColor: "#268088",
                  mb: 3,
                }}
              />

              {/* Title */}
              <Typography
                sx={{
                  fontSize: { xs: "1.4rem", md: "1.6rem" },
                  fontWeight: 700,
                  fontFamily: "Outfit",
                  color: "#FFFFFF",
                  mb: 3,
                  lineHeight: 1.3,
                }}
              >
                {feature.title}
              </Typography>

              {/* Description */}
              <Typography
                sx={{
                  fontSize: { xs: "0.95rem", md: "1rem" },
                  fontWeight: 400,
                  fontFamily: "Outfit",
                  color: "#FFFFFF",
                  lineHeight: 1.6,
                }}
              >
                {feature.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Call to Action Section */}
      <Box
        sx={{
          backgroundColor: "#242424",
          borderRadius: "20px",
          padding: { xs: "32px 24px", md: "48px 40px", lg: "60px 50px" },
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
          {/* Left Side   Content */}
          <Grid item xs={12} md={6}>
            <Box>
              {/* Title */}
              <Typography
                sx={{
                  fontSize: { xs: "1.5rem", md: "1.8rem", lg: "2rem" },
                  fontWeight: 700,
                  fontFamily: "Outfit",
                  color: "#FFFFFF",
                  mb: 3,
                  lineHeight: 1.3,
                }}
              >
                Enjoy a Free Demo to Personalize Your Meal Plan
              </Typography>

              {/* Subtitle */}
              <Typography
                sx={{
                  fontSize: { xs: "1rem", md: "1.1rem" },
                  fontWeight: 400,
                  fontFamily: "Outfit",
                  color: "rgba(255, 255, 255, 0.8)",
                  mb: 4,
                  lineHeight: 1.6,
                }}
              >
                Experience how Fitify creates a smart, tailored diet just for
                you.
              </Typography>

              {/* Bullet Points */}
              <Box sx={{ mb: 4 }}>
                {demoFeatures.map((feature, index) => (
                  <Box
                    key={index}
                    sx={{ display: "flex", alignItems: "center", mb: 2 }}
                  >
                    <Box
                      sx={{
                        width: "20px",
                        height: "20px",
                        backgroundColor: "#4ef4ff",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "12px",
                        fontSize: "12px",
                        color: "#000000",
                      }}
                    >
                      ✓
                    </Box>
                    <Typography
                      sx={{
                        fontSize: { xs: "0.95rem", md: "1rem" },
                        fontWeight: 400,
                        fontFamily: "Outfit",
                        color: "#FFFFFF",
                        lineHeight: 1.5,
                      }}
                    >
                      {feature}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {/* Button */}
              <Button 
                onClick={() => navigate('/', { state: { scrollTo: "book-demo" } })}
                sx={{
                  backgroundColor: "#4ef4ff",
                  color: "#000000",
                  fontWeight: 700,
                  borderRadius: "12px",
                  textTransform: "none",
                  padding: "14px 32px",
                  fontSize: "1rem",
                  fontFamily: "Outfit",
                  "&:hover": {
                    backgroundColor: "#3bd6e0",
                    transform: "translateY(-2px)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                Book Free Demo Today
              </Button>
            </Box>
          </Grid>

          {/* Right Side   Image */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                width: "100%",
                height: { xs: "300px", md: "400px" },
                borderRadius: "20px",
                overflow: "hidden",
              }}
            >
              <Box
                component="img"
                src={require("assets/images/about9.png")}
                alt="Healthy Breakfast Bowl"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default WhyCollaborateSection;
